export default __webpack_public_path__ + "static/media/new_HS.77b39ef8.svg";